<template>
  <div class="container my-4">
    <!-- Heading -->
    <div class="heading" role="alert">
      <h4>📊 Attendance Summary</h4>
    </div>

    <!-- Filters -->
    <div class="mb-4 d-flex flex-column flex-sm-row align-items-start gap-2">

    <select v-model="selectedTeacher" class="form-control shadow-sm" id="teacher">
      <option value="">-- All Teachers --</option>
      <option v-for="teacher in teachers" :key="teacher.id" :value="teacher.id">
        {{ teacher.user.first_name }}
      </option>
    </select>

        <select v-model="selectedSubject" class="form-select" id="subject">
          <option value="">-- All Subjects --</option>
          <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
            {{ subject.name }}
          </option>
        </select>

        <select v-model="selectedGrade" class="form-select" id="grade">
          <option value="">-- All Grades --</option>
          <option v-for="grade in grades" :key="grade.id" :value="grade.id">
            {{ grade.grade_level }}
          </option>
        </select>

      <input type="date" v-model="selectedDate" class="form-control" />
    </div>

    <!-- Loading Spinner -->
    <div v-if="loading" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Message Label -->
    <div v-else-if="message" class="alert alert-warning">
      {{ message }}
    </div>

    <div v-if="counts" class="mb-3">
  <span class="badge bg-primary me-2">
    Total Students: {{ counts.total_students }}
  </span>
  <span class="badge bg-success me-2">
    Present: {{ counts.present }}
  </span>
  <span class="badge bg-danger">
    Absent: {{ counts.absent }}
  </span>
</div>

    <!-- Attendance Table -->
    <!-- <table v-else class="table table-bordered table-striped"> -->
      <table v-if="studentsAttendance.length" class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Student</th>
          <th>Grade</th>
          <th>Teacher</th>
          <th>Subject</th>
          <th>Status</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="student in studentsAttendance" :key="student.id">
          <td>{{ student.name }}</td>
          <td>{{ student.grade_level || '-' }}</td>
          <td>{{ student.teacher.first_name || '-' }}</td>
          <td>{{ student.subject.name || '-' }}</td>
          <td>
            <span v-if="student.attendance_status === 'present'" class="text-success fw-bold">
              ✅ Present
            </span>
            <span v-else class="text-danger fw-bold">❌ Absent</span>
          </td>
          <!-- <td>
            <span v-if="student.attendance_status === 'present'" class="text-success fw-bold">
              ✅ Present
            </span>
            <span v-else-if="student.attendance_status === 'absent'" class="text-danger fw-bold">
              ❌ Absent
            </span>
            <span v-else class="text-secondary fw-bold">
              ⏳ Not Marked
            </span>
          </td> -->
          <td>
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#remarkModal" @click="selectedRemark = student.remarks || 'No remark'">
              View
            </button>
          </td>
          <!-- <td>{{ student.remarks || '-' }}</td> -->
        </tr>
      </tbody>
    </table>


    <!-- Modal -->
<div class="modal fade" id="remarkModal" tabindex="-1" aria-labelledby="remarkModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="remarkModalLabel">Student Remark</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        {{ selectedRemark }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      instituteId: null,
      token: null,
      subjects: [],
      selectedSubject: '',
      grades: [],
      selectedGrade: '',
      teachers: [],
      selectedTeacher: '',
      selectedDate: new Date().toISOString().slice(0, 10),
      studentsAttendance: [],
      message: "", // message for no data or error
      loading: false, // loading spinner
      counts: null,
      selectedRemark: '',
    };
  },

  created() {
    this.instituteId = localStorage.getItem('institute_id');
    this.token = localStorage.getItem('token');
    this.fetchSubjects();
    this.fetchGrades(); // Fetch grades on creation if instituteId exists
    this.fetchTeachers();
  },

  watch: {
  selectedSubject() {
    this.loadAttendance();
  },
  selectedGrade() {
    this.loadAttendance();
  },
  selectedTeacher() {
    this.loadAttendance();
  },
  selectedDate() {
    this.loadAttendance();
  },
},


  methods: {

    fetchTeachers() {
        const instituteId = localStorage.getItem('institute_id');
  
        axios.get('/get-teachers-by-institute', {
          params: { institute_id: instituteId }
        })
        .then(response => {
          this.teachers = response.data;
        })
        .catch(error => {
          console.error('Error fetching teachers:', error);
        });
      },


    fetchSubjects() {
      axios
        .get('/get-subjects-by-institute', {
          params: { institute_id: this.instituteId },
        })
        .then((response) => {
          this.subjects = response.data;
        })
        .catch((error) => {
          console.error('Error fetching subjects:', error);
        });
    },

    fetchGrades() {
      axios
        .get('/get-grades-by-institute', {
          params: { institute_id: this.instituteId },
        })
        .then((response) => {
          this.grades = response.data;
        })
        .catch((error) => {
          console.error('Error fetching grades:', error);
        });
    },
    
    async loadAttendance() {
      const instituteId = localStorage.getItem("institute_id");
      this.loading = true;
      this.message = "";
      this.studentsAttendance = [];
      this.counts = null;

      try {
        const { data } = await axios.post("/get-inst-attendance-with-students", {
          institute_id: instituteId,
          subject_id: this.selectedSubject,
          grade_id: this.selectedGrade,
          teacher_id: this.selectedTeacher,
          attendance_date: this.selectedDate,
        });

        if (!data.success || data.data.length === 0) {
          this.message = data.message || "Attendance not available.";
        } else {
          this.studentsAttendance = data.data;
          this.counts = data.counts;
        }
      } catch (error) {
        console.error("Error loading attendance:", error);
        this.message = "Error loading attendance. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    
  },

  mounted() {
    this.loadAttendance();
  },
};
</script>

<style lang="scss" scoped>
.heading{
    background-color: #696969;
    border: 2px solid #b8b8b8;
    border-radius: 5px;
    padding: 10px;
    color: white;
    margin-bottom: 5dvh;
  }
</style>